import { EventRegistryCategory } from '../../EventRegistryCategory';
import { EventRegistryItem } from '../../EventRegistryItem';
export class EventRegistryReactUI extends EventRegistryCategory {
    label = 'UI Events';
    constructor(parent) {
        super(parent);
        super.init();
    }
    scroll = () => new EventRegistryItem({ handlerName: 'onScroll' });
    toggle = () => new EventRegistryItem({ handlerName: 'onToggle' });
    wheel = () => new EventRegistryItem({ handlerName: 'onWheel' });
}
